import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.prediction)?_c(VCard,[_c('toolbar',{attrs:{"mode":"prediction","item":_vm.prediction}}),_c('prediction',{attrs:{"applications":_vm.applications,"datasets":_vm.datasets,"prediction":_vm.prediction},on:{"submitted":_vm.onSubmit}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }